import store from '@/store/'

export default async (to, from, next) => {
	if (!store.getters.getToken) {
		next({ name: 'signin' })
	}

	next()
}
